import { query, serviceQueries } from '@estee/elc-service-bus';

interface IShade {
    hexVal: string;
    name: string;
}

interface ISku {
    shades: IShade[];
    skuId: string;
}

interface IProduct {
    skus: ISku[];
    productId: string;
}

export class ProductRepository {
    private skus: ISku[] = [];

    public getSkuById = async (skuId: string) => {
        const sku = this.findSkuById(skuId);
        if (sku) {
            return sku;
        }

        const product = await this.getProductBySkuId(skuId);

        if (product) {
            this.skus = [...this.skus, ...product.skus];

            return this.findSkuById(skuId);
        }
    };

    private async getProductBySkuId(skuId: string) {
        const productData = <IProduct[]>await query(serviceQueries.GET_PRODUCT_DATA, {
            filterBy: { skus: { skuIds: [skuId] } }
        });

        if (productData?.length > 0) {
            return productData[0];
        }
    }

    private findSkuById(skuId: string) {
        return this.skus.find((sku) => sku.skuId === skuId);
    }
}
